const getBackgroundImageSource = (blockNode) => {
  const backgroundContainer = blockNode.querySelector('ws-background-container');
  return backgroundContainer && backgroundContainer.src;
};

export default getBackgroundImageSource;
